import { render } from "./Team_post_investment_operation_en_m.vue?vue&type=template&id=ee497dde&scoped=true"
import script from "./Team_post_investment_operation_en_m.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_operation_en_m.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ee497dde"

export default script